import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './translations/english';
import finnish from './translations/finnish';

i18n.use(initReactI18next).init({
  defaultNS: 'translation',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  lng: 'en',
  resources: {
    en: {
      translation: english,
    },
    fi: {
      translation: finnish,
    },
  },
});

export default i18n;
